export enum InvoiceItemStatus {
  autoSuccess = 'auto (success)',
  autoWarning = 'auto (warning)',
  autoError = 'auto (error)',
  manual = 'manual',
}

export const getInvoiceItemStatusFromValue = (value): InvoiceItemStatus => {
  const index = Object.values(InvoiceItemStatus).indexOf(value);
  if (index < 0) {
    throw new Error('Unknown invoice item status ' + value);
  }

  return Object.keys(InvoiceItemStatus)[index] as InvoiceItemStatus;
};
